import React from 'react';
import { TimePicker, TimeRangePickerProps } from 'antd';
import { Moment } from 'moment';

import styles from './time-range-picker.module.scss';

const { RangePicker } = TimePicker;

export type DateRangePickerProps = {} & TimeRangePickerProps & React.RefAttributes<any>;

const getTimeString = (date: Moment) => {
	const hours = `${date.hours()}`.padStart(2, '0');
	const minutes = `${date.minutes()}`.padStart(2, '0');
	const seconds = `${date.seconds()}`.padStart(2, '0');

	return `${hours}:${minutes}:${seconds}`;
};

const TimeRangePicker: React.FunctionComponent<DateRangePickerProps> = (props: DateRangePickerProps) => {
	const reorderByTime = (rangeDates: Moment[] | null) => {
		const firstTimeDate = getTimeString(rangeDates[0]);
		const secondTimeDate = getTimeString(rangeDates[1]);

		if (firstTimeDate > secondTimeDate) {
			rangeDates.reverse();
		}
	};

	const onChange = (rangeDates: [Moment, Moment] | null, formatString) => {
		const { value, onChange, order = true } = props;

		if (!rangeDates) {
			onChange(rangeDates, formatString);
			return;
		}

		if (order) {
			reorderByTime(rangeDates);
		}

		let firstDate = rangeDates[0];
		let secondDate = rangeDates[1];

		if (value) {
			firstDate = value[0]
				.clone()
				.set({ hour: rangeDates[0].hour(), minute: rangeDates[0].minute(), seconds: rangeDates[0].second() });
			secondDate = value[1]
				.clone()
				.set({ hour: rangeDates[1].hour(), minute: rangeDates[1].minute(), seconds: rangeDates[1].second() });
		}

		onChange([firstDate, secondDate], formatString);
	};

	return (
		<RangePicker
			data-test-id="time-range-picker"
			{...props}
			className={`bringg-picker ${props.className || ''}`}
			popupClassName={`bringg-picker-dropdown ${styles.timeRangePickerPopup} ${props.popupClassName || ''}`}
			onChange={onChange}
		/>
	);
};

export default TimeRangePicker;
